import {
  Download1Stroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { formatDate } from '@/lib/formatUtils';
import { SearchFormValues } from '../schema';

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onPrintClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportDataClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  className?: string;
  searchParams?: SearchFormValues;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onPrintClick,
  onFixedColumnsClick,
  onExportDataClick,
  onEditPrintTemplateClick,
  className,
  searchParams
}) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Báo cáo tình trạng đơn hàng mua</h1>
          <div className='text-[10px] text-gray-500'>
            <p>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              <span className='font-semibold'>Từ ngày {formatDate(searchParams?.ngay_ct1) || '--/--/----'}</span>
              <span> đến ngày </span>
              <span className='font-semibold'>{formatDate(searchParams?.ngay_ct2) || '--/--/----'}</span>
              {searchParams?.status && (
                <>
                  <span className='ml-1'>,Trạng thái: </span>
                  <span className='font-semibold'>
                    {searchParams.status === '' && 'Tất cả'}
                    {searchParams.status === '0' && 'Lập chứng từ'}
                    {searchParams.status === '1' && 'Chờ duyệt'}
                    {searchParams.status === '4' && 'Đang duyệt'}
                    {searchParams.status === '5' && 'Đã duyệt'}
                    {searchParams.status === '6' && 'Đang thực hiện'}
                    {searchParams.status === '7' && 'Hoàn thành'}
                    {searchParams.status === '9' && 'Đóng'}
                  </span>
                </>
              )}
            </p>
          </div>
        </div>
      }
    >
      {onSearchClick && (
        <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      )}
      {/* No print button */}
      {onRefreshClick && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='destructive'
        />
      )}
      {onFixedColumnsClick && (
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
      {onExportDataClick && (
        <ActionButtonV2
          icon={Download1Stroke}
          title='Kết xuất dữ liệu'
          onClick={onExportDataClick}
          variant='secondary'
        />
      )}
      <MenuButtonV2
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
